import ReactDOM from 'react-dom/client';
import "./index.css";
import 'react-toastify/dist/ReactToastify.css';
import Routing from './router/routing';
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Router>
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored" />
        <Routing />
    </Router>
);